import { BenefitsListPage } from '../@types/benefitsListPage';
import { WELCOME_MODAL } from '../domain/routes';

export const getShouldRefetchProductsAndEntitlements = ({
  benefitsPage,
  hasMieterPlus,
  hasWohnenPlus,
  hasWohnenPlusLight,
  hasSuccessSearchParam,
  nestedPath,
  areProductsLoading,
}: {
  hasMieterPlus: boolean;
  hasWohnenPlus: boolean;
  hasWohnenPlusLight: boolean;
  hasSuccessSearchParam: boolean;
  areProductsLoading: boolean;
  nestedPath: string | null;
  benefitsPage: BenefitsListPage;
}) => {
  if (areProductsLoading) return false;
  if (nestedPath !== WELCOME_MODAL) return false;
  if (benefitsPage === BenefitsListPage.KauferPlus) return false;
  const shouldRefetchForMieterPlus =
    benefitsPage === BenefitsListPage.MieterPlus && !hasMieterPlus && hasSuccessSearchParam;
  const shouldRefetchForWohnenPlus =
    benefitsPage === BenefitsListPage.WohnenPlus && !hasWohnenPlus && !hasWohnenPlusLight && hasSuccessSearchParam;
  return shouldRefetchForMieterPlus || shouldRefetchForWohnenPlus;
};
